import { t } from "i18next";
import { PaymentStatus } from "store/types";

export const paymentOptions = () =>
    [
        { label: t("Articles.NotPaid"), value: PaymentStatus.NOT_PAID },
        { label: t("Articles.ToPay"), value: PaymentStatus.TO_PAY },
        { label: t("Articles.Paid"), value: PaymentStatus.PAID },
    ] as PaymentOption[];

export const paymentColorRules = {
    [PaymentStatus.NOT_PAID]: "#9B5067",
    [PaymentStatus.TO_PAY]: "#275AB0",
    [PaymentStatus.PAID]: "#267847",
} as StatusSelectColorRules;

export type PaymentOption = { label: string; value: number };

export type StatusSelectColorRules = Record<string | number, string>;
